import { baseApi } from "../baseApi";

export const productApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createProduct: builder.mutation({
      query: (formData) => ({
        url: "/product-create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Product"],
    }),
    createProductImage: builder.mutation({
      query: (formData) => ({
        url: "/product-image-create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Product"],
    }),
    getProduct: builder.query({
      query: ({ page = 1, limit = 10, search = "", status = "", } = {}) =>
        //  "/category-list",
        `/product-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,

      providesTags: ["Product"],
    }),
    updateProduct: builder.mutation({
      query: (formData) => ({
        url: `/product-update`,
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["Product"],
    }),
    updateProductImages: builder.mutation({
      query: (formData) => ({
        url: `/product-image-update`,
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["Product"],
    }),

    getSingleProduct: builder.query({

      query: (id) => ({
        url: `/product-view/${id}`,
        method: "GET",
      }),

      providesTags: ["Product"],
    }),

    viewProductImages: builder.query({
      query: (id) => ({
        url: `/product-images-list/${id}`,
        method: "GET",
      }),
      providesTags: ["Product"],
    }),
    changeProductStatus: builder.mutation({
      query: (id) => ({
        url: `/product-status/${id}`,
        method: "GET",
      }),

      invalidatesTags: ["Product"],
    }),
    deleteProduct: builder.mutation({
      query: (data) => ({
        url: `/product-delete`,
        method: "DELETE",
        body: data
      }),
      invalidatesTags: ["Product"],
    }),

  }),
});

export const { useCreateProductMutation, useCreateProductImageMutation, useGetProductQuery,useViewProductImagesQuery, useChangeProductStatusMutation, useGetSingleProductQuery, useUpdateProductMutation,useUpdateProductImagesMutation, useDeleteProductMutation, } = productApi;